<div class="modal-header">
    <h4 class="modal-title">Order Ship Address</h4>
</div>
<div class="modal-body">
    <dx-form [formData]="order" *ngIf="order">
        <dxi-item itemType="group">
            <dxi-item [label]="{ text: 'Ship To Locations' }">
                <div *dxTemplate>
                    <dx-select-box
                        [(value)]="selectedAddress"
                        [items]="addresses"
                        displayExpr="displayName"
                        [showClearButton]="false"
                        (onValueChanged)="selectedAddressChanged($event)"
                    ></dx-select-box>
                </div>
            </dxi-item>
            <dxi-item dataField="shipToLocation" [label]="{ text: 'Location' }"></dxi-item>
            <dxi-item dataField="shipToEmail" [label]="{ text: 'Email' }" [label]="{ text: 'Confirmation Email' }"></dxi-item>
            <dxi-item dataField="shipToContactName" [label]="{ text: 'Contact Name' }"></dxi-item>
            <dxi-item dataField="shipToAddress1" [label]="{ text: 'Address 1' }"></dxi-item>
            <dxi-item dataField="shipToAddress2" [label]="{ text: 'Address 2' }"></dxi-item>
            <dxi-item itemType="group" [colCount]="3" caption="">
                <dxi-item dataField="shipToCity" [colSpan]="2" [label]="{ text: 'City' }"></dxi-item>
                <dxi-item dataField="shipToState" [visible]="selectedCountry !== 'US'" [label]="{ text: 'State' }"></dxi-item>
                <dxi-item
                    dataField="shipToState"
                    editorType="dxSelectBox"
                    [editorOptions]="{ items: states, showClearButton: false }"
                    [visible]="selectedCountry === 'US'"
                    [label]="{ text: 'State' }"
                ></dxi-item>
                <dxi-item dataField="shipToZip" [label]="{ text: 'Zip' }"></dxi-item>
                <dxi-item [label]="{ text: 'Country' }">
                    <div *dxTemplate>
                        <dx-select-box [(value)]="selectedCountry" [items]="countries" [showClearButton]="false" (onValueChanged)="selectedCountryChanged($event)"></dx-select-box>
                    </div>
                </dxi-item>
                <dxi-item dataField="shipToCountry" [visible]="selectedCountry === 'OTHER'" [label]="{ text: 'Country' }"></dxi-item>
            </dxi-item>
            <dxi-item itemType="group" [colCount]="2" caption="">
                <dxi-item dataField="shipToPhone" [label]="{ text: 'Phone' }" [label]="{ text: 'Phone' }"></dxi-item>
            </dxi-item>
            <dxi-item dataField="shippingNote" [label]="{ text: 'Shipping Notes' }" editorType="dxTextArea" [editorOptions]="{ height: '150px' }"></dxi-item>
        </dxi-item>
    </dx-form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-success me-auto" (click)="editDealer()">Edit Dealer</button>
    <button type="button" class="btn btn-success" (click)="save()">Save</button>
    <button type="button" class="btn btn-light" (click)="cancel()">Cancel</button>
</div>
